import {
  createLabel as publicCreateLabel,
  getLabel as publicGetLabel,
  listLabels as publicListLabels,
  queryLabels as publicQueryLabels,
  typedQueryLabels as publicTypedQueryLabels,
  countLabels as publicCountLabels,
  updateLabel as publicUpdateLabel,
  deleteLabel as publicDeleteLabel,
  bulkDeleteLabels as publicBulkDeleteLabels,
} from './restaurants-menus-v1-item-label-item-labels.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  LabelQuery,
  LabelsQueryBuilder,
  typedQueryLabels as universalTypedQueryLabels,
} from './restaurants-menus-v1-item-label-item-labels.universal.js';
import { onItemLabelCreated as publicOnItemLabelCreated } from './restaurants-menus-v1-item-label-item-labels.public.js';
import { onItemLabelDeleted as publicOnItemLabelDeleted } from './restaurants-menus-v1-item-label-item-labels.public.js';
import { onItemLabelUpdated as publicOnItemLabelUpdated } from './restaurants-menus-v1-item-label-item-labels.public.js';

function customQueryLabels(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryLabels(httpClient)(),
    typedQueryFunction: (query: LabelQuery) =>
      publicTypedQueryLabels(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): LabelsQueryBuilder;
  function overloadedQuery(
    query: LabelQuery
  ): ReturnType<typeof universalTypedQueryLabels>;
  function overloadedQuery(query?: LabelQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createLabel: MaybeContext<
  BuildRESTFunction<typeof publicCreateLabel> & typeof publicCreateLabel
> = /*#__PURE__*/ createRESTModule(publicCreateLabel);
export const getLabel: MaybeContext<
  BuildRESTFunction<typeof publicGetLabel> & typeof publicGetLabel
> = /*#__PURE__*/ createRESTModule(publicGetLabel);
export const listLabels: MaybeContext<
  BuildRESTFunction<typeof publicListLabels> & typeof publicListLabels
> = /*#__PURE__*/ createRESTModule(publicListLabels);
export const countLabels: MaybeContext<
  BuildRESTFunction<typeof publicCountLabels> & typeof publicCountLabels
> = /*#__PURE__*/ createRESTModule(publicCountLabels);
export const updateLabel: MaybeContext<
  BuildRESTFunction<typeof publicUpdateLabel> & typeof publicUpdateLabel
> = /*#__PURE__*/ createRESTModule(publicUpdateLabel);
export const deleteLabel: MaybeContext<
  BuildRESTFunction<typeof publicDeleteLabel> & typeof publicDeleteLabel
> = /*#__PURE__*/ createRESTModule(publicDeleteLabel);
export const bulkDeleteLabels: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteLabels> &
    typeof publicBulkDeleteLabels
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteLabels);
export const queryLabels: MaybeContext<
  BuildRESTFunction<typeof customQueryLabels> & typeof customQueryLabels
> = /*#__PURE__*/ createRESTModule(customQueryLabels);
/**
 * Triggered when an item label is created.
 */
export const onItemLabelCreated: BuildEventDefinition<
  typeof publicOnItemLabelCreated
> &
  typeof publicOnItemLabelCreated = createEventModule(publicOnItemLabelCreated);
/** */
export const onItemLabelDeleted: BuildEventDefinition<
  typeof publicOnItemLabelDeleted
> &
  typeof publicOnItemLabelDeleted = createEventModule(publicOnItemLabelDeleted);
/**
 * Triggered when an item label is updated.
 */
export const onItemLabelUpdated: BuildEventDefinition<
  typeof publicOnItemLabelUpdated
> &
  typeof publicOnItemLabelUpdated = createEventModule(publicOnItemLabelUpdated);

export {
  SortOrder,
  WebhookIdentityType,
} from './restaurants-menus-v1-item-label-item-labels.universal.js';
export {
  Label,
  ExtendedFields,
  ExternalReferenceInfo,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateLabelRequest,
  CreateLabelResponse,
  GetLabelRequest,
  GetLabelResponse,
  ListLabelsRequest,
  ListLabelsResponse,
  QueryLabelsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryLabelsResponse,
  CursorPagingMetadata,
  Cursors,
  CountLabelsRequest,
  CountLabelsResponse,
  UpdateLabelRequest,
  UpdateLabelResponse,
  DeleteLabelRequest,
  DeleteLabelResponse,
  BulkDeleteLabelsRequest,
  BulkDeleteLabelsResponse,
  BulkDeleteLabelsResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  CloneLabelsRequest,
  CloneLabelsResponse,
  SyncContentToMultilingualRequest,
  SyncContentToMultilingualResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  ItemLabelCreatedEnvelope,
  ItemLabelDeletedEnvelope,
  ItemLabelUpdatedEnvelope,
  LabelsQueryResult,
  LabelsQueryBuilder,
  LabelQuerySpec,
  CountLabelsOptions,
  UpdateLabel,
} from './restaurants-menus-v1-item-label-item-labels.universal.js';
export { utils } from './restaurants-menus-v1-item-label-item-labels.universal.js';
export {
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CountLabelsApplicationErrors,
  CommonQueryWithEntityContext,
  LabelQuery,
} from './restaurants-menus-v1-item-label-item-labels.universal.js';
